<template>
  <div class="px-3 pb-3">
    <b-form id="address-search-form" class="mt-2" v-if="addressSearchTool">
      <span>Wyszukaj po adresie</span>
      <b-form-group label="" label-for="address-search-query-autocomplete">
        <div @click="showAddressSearchContextAssistant">
          <autocomplete
            :disabled="searchResultsLoading"
            ref="autocompleteAddress"
            id="address-search-query-autocomplete"
            v-model="autocompleteSelectedItem"
            :items="addressAutocompleteItems"
            @item-selected="addressAutocompleteItemSelected"
            @update-items="addressAutocompleteUpdated"
            :get-label="getAutocompleteLabel"
            :input-attrs="{
              placeholder: 'np. Warszawa, Aleja Jana Pawła II 49',
              class: 'form-control'
            }"
            :min-len="0"
            :auto-select-one-item="false"
            :component-item="autocompleteTemplate"
          >
          </autocomplete>
        </div>
      </b-form-group>
      <span>Wyszukaj po współrzędnych</span>
      <b-row @click="showCoordinatesSearchContextAssistant"
        ><small
          class="text-danger ml-3 mr-3 mb-1 mt-1"
          v-show="
            formErrors.searchCoordinates.x || formErrors.searchCoordinates.y
          "
          >Należy wybrać prawidłową szerokośc i długość geograficzną</small
        >
        <b-col md="6">
          <b-form-input
            type="number"
            id="x-coord-input"
            v-model="searchCoordinates.x"
            placeholder="X"
            :class="{
              'form-control': true
            }"
          ></b-form-input>
        </b-col>
        <b-col md="6">
          <b-form-input
            type="number"
            id="y-coord-input"
            v-model="searchCoordinates.y"
            placeholder="Y"
            :class="{
              'form-control': true
            }"
          ></b-form-input>
        </b-col>
        <b-col class="mt-1" v-if="!isMobileVersion"
          >Promień koła wyszukiwania<b-select v-model="selectedSearchRadius">
            <option
              v-for="radius in radiuses"
              :value="radius.value"
              :key="radius.value"
            >
              {{ radius.text }}
            </option>
          </b-select></b-col
        >
      </b-row>
      <b-btn
        :disabled="searchResultsLoading"
        @click="coordinatesSearch"
        variant="primary"
        class="col-md-12 mt-3"
        size="sm"
      >
        <span v-if="!searchResultsLoading">Szukaj</span>
        <span v-else><icon name="circle-notch" spin></icon></span>
      </b-btn>
    </b-form>
    <div v-if="selectedAddressObject" class="additional-section">
      <div
        @click="isCollapsed = !isCollapsed"
        class="mb-2"
        style="cursor: pointer;"
      >
        <span v-if="isCollapsed">&#9656;</span>
        <span v-else>&#9662;</span>
        Wybrany adres
      </div>

      <b-collapse v-model="isCollapsed">
        <div>
          <p><strong>Miasto: </strong> {{ selectedAddressSearchItem.city }}</p>
          <p v-if="selectedAddressSearchItem.street">
            <strong>Ulica: </strong> {{ selectedAddressSearchItem.street }}
            <span
              v-if="selectedAddressSearchItem.historicStreet"
              class="text-muted"
            >
              <small
                >(do {{ selectedAddressSearchItem.streetStateOn }}
                {{ selectedAddressSearchItem.historicStreet }})</small
              >
            </span>
          </p>
          <p>
            <strong>Numer budynku: </strong>
            {{ selectedAddressSearchItem.number }}
          </p>
          <p>
            <strong>Kod pocztowy: </strong>
            {{ selectedAddressSearchItem.postalCode }}
          </p>
          <p>
            <strong>Województwo: </strong>
            {{
              selectedAddressSearchItem.voivodeship
                ? selectedAddressSearchItem.voivodeship.toLowerCase()
                : ''
            }}
          </p>
          <p>
            <strong>Powiat: </strong> {{ selectedAddressSearchItem.county }}
          </p>
          <p>
            <strong>Gmina: </strong> {{ selectedAddressSearchItem.commune }}
          </p>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Autocomplete from 'v-autocomplete';
import AutocompleteItem from './AutocompleteItem.vue';
import { mapGetters } from 'vuex';
import {
  SEARCH_ADDRESS_SET_SELECTED_OBJECT,
  SEARCH_LOADER_SHOW,
  SEARCH_LOADER_HIDE,
  REPORT_DEMAND_POPUP_SHOW,
  WINDOW_NOTIFICATION_SHOW,
  SEARCH_ADDRESS_SET_RADIUS
} from '../../store/mutations.type';
import {
  SEARCH_COORDINATE_FOR_ADDRESS_GET,
  SEARCH_OBJECTS_WFS_GET,
  DISPLAY_CONTEXT_ASSISTANT_MESSAGE
} from '../../store/actions.type';
import { Api as ZglaszaniePopytuApi } from '../../api/api-zglaszanie-popytu';

export default {
  name: 'AddressSearch',
  components: {
    Autocomplete,
    AutocompleteItem
  },
  computed: {
    ...mapGetters([
      'addressSearchTool',
      'selectedAddressSearchItem',
      'searchResultsLoading',
      'contextAssistantActive',
      'isMobileVersion'
    ]),
    selectedAddressObject() {
      return this.selectedAddressSearchItem;
    }
  },
  data() {
    return {
      autocompleteSelectedItem: null,
      addressAutocompleteItems: [],
      autocompleteTemplate: AutocompleteItem,
      searchCoordinates: { x: null, y: null },
      formErrors: { searchCoordinates: { x: null, y: null } },
      isCollapsed: false,
      selectedSearchRadius: 0,
      radiuses: [
        { text: '0m', value: 0 },
        { text: '100m', value: 0.1 },
        { text: '200m', value: 0.2 },
        { text: '300m', value: 0.3 },
        { text: '400m', value: 0.4 },
        { text: '500m', value: 0.5 }
      ]
    };
  },
  methods: {
    async addressAutocompleteUpdated(text) {
      this.$store.commit(SEARCH_LOADER_SHOW);

      var response = await this.$store.dispatch(
        SEARCH_COORDINATE_FOR_ADDRESS_GET,
        { address: text }
      );

      this.addressAutocompleteItems =
        response != null ? Object.values(response) : [];

      this.$store.commit(SEARCH_LOADER_HIDE);
    },
    getAutocompleteLabel(item) {
      if (item && item != null) {
        if (item.street && item.number) {
          return `${item.street} ${item.number}, ${item.city}`;
        } else if (item.street) {
          return `${item.street}, ${item.city}`;
        } else if (item.number) {
          return `${item.city} ${item.number}`;
        } else {
          return `${item.city}, ${item.voivodeship}, ${item.county}, ${item.commune}`;
        }
      }
      return this.$refs.autocompleteAddress.searchText;
    },
    async addressAutocompleteItemSelected(item) {
      this.searchCoordinates.x = item.x;
      this.searchCoordinates.y = item.y;
      await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {});
      await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, item);
      if (this.selectedSearchRadius == 0) {
        this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
          context: this,
          address: {
            simc: item.simc,
            terc: item.teryt,
            ulic: item.streetSymbol,
            number: item.number,
            x: item.x,
            y: item.y
          }
        });
      } else {
        this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
          context: this,
          point: { x: item.x, y: item.y },
          radius: this.selectedSearchRadius
        });
      }
    },
    async coordinatesSearch() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Przycisk "Szukaj" uruchamia operację wyszukiwania po współżędnych.'
        });
      } else {
        const validX = this.searchCoordinates.x > 0;
        const validY = this.searchCoordinates.y > 0;
        if (
          this.validCoordinates(validX, validY) &&
          this.selectedSearchRadius === 0
        ) {
          await this.fetchAddressByCoordinates();
        } else if (
          this.validCoordinates(validX, validY) &&
          this.selectedSearchRadius !== 0
        ) {
          await this.$store.commit(SEARCH_ADDRESS_SET_SELECTED_OBJECT, {
            x: this.searchCoordinates.x,
            y: this.searchCoordinates.y
          });
          this.$store.dispatch(SEARCH_OBJECTS_WFS_GET, {
            context: this,
            point: { x: this.searchCoordinates.x, y: this.searchCoordinates.y },
            radius: this.selectedSearchRadius
          });
        } else if (this.autocompleteSelectedItem !== null) {
          await this.addressAutocompleteItemSelected(
            this.autocompleteSelectedItem
          );
        } else {
          this.formErrors.searchCoordinates.x = !validX;
          this.formErrors.searchCoordinates.y = !validY;
        }
      }
    },
    validCoordinates(validX, validY) {
      return validX && validY;
    },
    extractEpsgNumber(coordinateSystem) {
      return parseInt(coordinateSystem.split(':')[1]);
    },

    async fetchAddressByCoordinates() {
      try {
        const api = new ZglaszaniePopytuApi();
        const coordinateSystem = this.extractEpsgNumber(
          this.$store.getters.coordinateSystem
        );
        const response = await api.searchAddressByCoordinates(
          {
            body: {
              x: this.searchCoordinates.x.toString(),
              y: this.searchCoordinates.y.toString(),
              coordinateSystemCode: coordinateSystem
            }
          },
          {
            ignoreGlobalError: true,
            download: false,
            withCredentials: false,
            hasContentType: false,
            jsonData: true
          }
        );
        if (response) {
          const address = {
            teryt: response.body.teryt,
            simc: response.body.simc,
            number: response.body.number,
            streetSymbol: response.body.streetSymbol,
            city: response.body.city,
            street: response.body.street,
            postalCode: response.body.postalCode,
            voivodeship: response.body.voivodeship,
            county: response.body.county,
            commune: response.body.commune,
            x: this.searchCoordinates.x.toString(),
            y: this.searchCoordinates.y.toString()
          };
          await this.addressAutocompleteItemSelected(address);
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title:
            'Usługa wyszukiwania jest czasowo niedostępna. Spróbuj ponownie później'
        });
      }
    },
    showAddressSearchContextAssistant() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'W wybranym polu należy wpisać adres lub jego fragment który chcemy wyszukać, a następnie wybrać adres z listy proponowanych adresów.'
        });
      }
    },
    showCoordinatesSearchContextAssistant() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'W polach X i Y należy podać współżędne x(długość geograficzna) i y(szerokość geograficzna) a następnie kliknąć przycisk "Szukaj".'
        });
      }
    }
  },
  watch: {
    selectedSearchRadius() {
      this.$store.commit(SEARCH_ADDRESS_SET_RADIUS, this.selectedSearchRadius);
    }
  }
};
</script>
